import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Link } from "@chakra-ui/react";
import { ArrowLeft } from "lucide-react";
import { PRIVACY_POLICY_EMBED_URL, TERMS_OF_USE_EMBED_URL } from "../../constants/legal-links";

type DocumentType = "terms" | "privacy";

const documentConfig: Record<DocumentType, { url: string; title: string }> = {
  terms: {
    url: TERMS_OF_USE_EMBED_URL,
    title: "Terms of Use",
  },
  privacy: {
    url: PRIVACY_POLICY_EMBED_URL,
    title: "Privacy Policy",
  },
};

export default function DocumentViewer() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") as DocumentType | null;
  const returnTo = searchParams.get("returnTo") || "/login";
  const token = searchParams.get("token");

  const backUrl = token ? `${returnTo}?token=${token}` : returnTo;

  const config = type && documentConfig[type] ? documentConfig[type] : null;

  if (!config) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500">Document not found</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{config.title} | LaborHack Pro</title>
      </Helmet>
      <div className="min-h-screen bg-white">
        <div className="sticky top-0 z-10 bg-white border-b">
          <div className="px-6 py-4 flex items-center gap-4">
            <Link
              href={backUrl}
              className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft className="w-4 h-4" />
              Go back
            </Link>
            <h1 className="text-lg font-semibold text-gray-900">{config.title}</h1>
          </div>
        </div>
        <iframe
          src={config.url}
          className="w-full h-[calc(100vh-65px)] border-0"
          title={config.title}
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        />
      </div>
    </>
  );
}
